import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Loader2 } from 'lucide-react';
import { brandsAPI } from '../services/api';

const BrandsPage = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchBrands = async () => {
      try {
        const response = await brandsAPI.getAll();
        if (isMounted) {
          setBrands(response.data || []);
        }
      } catch (error) {
        if (isMounted && error.name !== 'CanceledError') {
          console.error('Error fetching brands:', error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchBrands();

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-bg-main flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-green" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg-main">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-6xl font-bold text-text-heading mb-4 font-heading">Shop by Brand</h1>
          <p className="text-2xl text-text-body font-body">Discover our curated collection of trusted makers</p>
        </div>

        {brands.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-xl text-text-body font-body">No brands available yet.</p>
            <Link to="/shop" className="text-accent hover:underline font-body mt-4 inline-block">
              Browse all products
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {brands.map((brand) => (
              <Link
                key={brand._id || brand.id}
                to={`/shop?brand=${encodeURIComponent(brand.name)}`}
                className="group bg-white rounded-2xl p-10 border-2 border-soft-sand hover:border-accent hover:shadow-soft-lg transition-all duration-300"
              >
                <div className="text-center">
                  {brand.logo_url && (
                    <img 
                      src={brand.logo_url} 
                      alt={brand.name} 
                      className="w-20 h-20 object-contain mx-auto mb-4"
                    />
                  )}
                  <h2 className="text-4xl font-bold text-text-heading mb-4 font-heading group-hover:text-accent transition-colors">
                    {brand.name}
                  </h2>
                  <p className="text-xl text-text-body font-body mb-6">
                    {brand.product_count || 0} premium products
                  </p>
                  <div className="flex items-center justify-center text-accent group-hover:gap-3 transition-all">
                    <span className="font-semibold font-body text-lg">Explore Collection</span>
                    <ArrowRight className="h-5 w-5 group-hover:translate-x-2 transition-transform" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandsPage;
